import { createSlice } from "@reduxjs/toolkit";
import { initialBusinessCertificateofInsuranceState } from "./businessCertificateofInsurance.types";
import { fetchBusinessCertificateOfInsuranceList } from "./businessCertificateofInsuranceActions";
import { LoadState } from "../../../constants/enums";

const businessCertificateofInsuranceSlice = createSlice({
  name: "businessCertificateofInsurance",
  initialState: initialBusinessCertificateofInsuranceState,
  reducers: {
    clearBusinessCertificateofInsuranceState: (state) => {
      return initialBusinessCertificateofInsuranceState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      fetchBusinessCertificateOfInsuranceList.pending,
      (state) => {
        state.loading = LoadState.InProgress;
        state.certificateOfInsuranceList = [];
      },
    );
    builder.addCase(
      fetchBusinessCertificateOfInsuranceList.fulfilled,
      (state, action) => {
        state.loading = LoadState.Loaded;
        state.certificateOfInsuranceList = action.payload.data;
        state.totalRecords = action.payload.totalRecords;
      },
    );
    builder.addCase(
      fetchBusinessCertificateOfInsuranceList.rejected,
      (state) => {
        state.loading = LoadState.Failed;
      },
    );
  },
});

export const { clearBusinessCertificateofInsuranceState } =
  businessCertificateofInsuranceSlice.actions;

export const businessCertificateofInsuranceReducer = businessCertificateofInsuranceSlice.reducer;
